import { useMutation, useQueryClient } from "@tanstack/react-query"
import { profile } from '@shared/api/services'
import { toast } from "react-toastify"

export const useUpdateVacation = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: (data) => profile.updateVacation(data),
		retry: 0,
		onSuccess: (res) => {
			queryClient.invalidateQueries(['profile'])
			toast.success(res?.data?.message || 'Состояние отпуска обновлено')
		},
	})

	return mutation
}
